import {getTelegramInitData} from "./telegramWebApp";

export const apiUrl = process.env.NODE_ENV === 'production' ?
    process.env.REACT_APP_PROD_API_URL :
    process.env.REACT_APP_DEV_API_URL;

// createURL создаёт URL с параметрами запуска для отправки
export function createURL(path) {
    const url = new URL(apiUrl + path);
    const tgInitData = getTelegramInitData();

    if (tgInitData) {
        url.searchParams.set("tg_init_data", tgInitData);
    }

    return url.toString();
}
